import { omit } from 'lodash/fp';
import { connect } from 'react-redux';
import {
  updateInventoryPackage,
  fetchInventoryPackage
} from '../../../../redux/Inventory/sagas/routines';
import { getAllValues as getTags } from '../../../../redux/Inventory/selectors/tag';
import {
  getIsFetching,
  getIsSaving,
  getIsSaved,
  getPackageForId
} from '../../../../redux/Inventory/selectors/package';
import { PackageType } from '../../../../constants/inventory/InventoryTypes';
import EditItem from '../component';

function mapStateToProps(state, { match: { params } }) {
  return {
    type: PackageType,
    tags: getTags(state),
    item: getPackageForId(state, params.id),
    isFetchingItem: getIsFetching(state),
    isSaved: getIsSaved(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  return {
    onInit: () => {
      dispatch(fetchInventoryPackage(params.id));
    },
    onSubmit: body => {
      const omitProps = [
        'id',
        'locationId',
        'items',
        'createdAt',
        'updatedAt',
        'deletedAt'
      ];
      const payload = { id: body.id, body: omit(omitProps, body) };
      dispatch(updateInventoryPackage(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditItem);
